import { GENERATE_FINAL_CHARGES_REQUEST, GENERATE_FINAL_CHARGES_SUCCESS, GENERATE_FINAL_CHARGES_FAILURE, GENERATE_FINAL_CHARGES_RESET, } from "../../actions";
const initialState = {
    data: "",
    isLoading: false,
    error: null,
};
const GenerateFinalChargesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GENERATE_FINAL_CHARGES_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case GENERATE_FINAL_CHARGES_SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, isLoading: false, error: null });
        case GENERATE_FINAL_CHARGES_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case GENERATE_FINAL_CHARGES_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, data: null, error: null });
        default:
            return state;
    }
};
export default GenerateFinalChargesReducer;
